import React, { useState, useRef,useEffect } from 'react';
import './OtpValidation.css';

const OtpValidation = (props) => {
  const [otp, setOtp] = useState(new Array(4).fill(''));
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [buttonSubmitted, setButtonSubmitted] = useState(false) // State for button disabled status
  const inputRefs = useRef([]);


  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);
  // Determine if submit button should be disabled based on input completeness
  const isSubmitDisabled = otp.some(value => value === '') || isButtonDisabled;

  const handleChange = (element, index) => {
    const value = element.value.replace(/[^0-9]/g, ''); // Allow only numbers
    setOtp((prev) => {
      const newOtp = [...prev];
      newOtp[index] = value;
      return newOtp;
    });

    // Move to the next input if the current input is filled
    if (value && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === 'Backspace') {
      setOtp((prev) => {
        const newOtp = [...prev];
        if (!otp[index] && index > 0) {
          inputRefs.current[index - 1].focus();
          newOtp[index - 1] = ''; // Clear previous input
        } else {
          newOtp[index] = ''; // Clear current input
        }
        return newOtp;
      });
    } else if (event.key === 'ArrowLeft' && index > 0) {
      inputRefs.current[index - 1].focus();
    } else if (event.key === 'ArrowRight' && index < otp.length - 1) {
      inputRefs.current[index + 1].focus();
    }
    else if (event.key === 'Enter' && !isSubmitDisabled) {
      // Trigger handleSubmit when Enter key is pressed
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    if (isSubmitDisabled) return; // Prevent submit if any field is empty or already submitted

    const OTP = otp.join('');
    props.workflowDataHandler(OTP);
    setIsButtonDisabled(true); // Disable button after submission
    setButtonSubmitted(true);
  };

  return (
    <div className="otp-container">
      <p className="textcolor" style={{fontWeight:"bold"}}>Please enter the OTP received on your registered mobile number</p>
      <div className="otp-inputs">
        {otp.map((value, index) => (
          <input
            key={index}
            type="text"
            style={{ backgroundColor: isButtonDisabled ? '#f0f0f0' : 'white' }}
            maxLength="1"
            value={value}
            onChange={(e) => handleChange(e.target, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            ref={(el) => (inputRefs.current[index] = el)}
            aria-label={`OTP Input ${index + 1}`}
            disabled={isButtonDisabled} // Disable input fields after submission
          />
        ))}
      </div>
      <button
        className="submit-button"
        style={{backgroundColor: buttonSubmitted ? 'grey' : 'rgba(12, 77, 162, 1)'}}
        onClick={handleSubmit}
        disabled={isSubmitDisabled}
      >
        SUBMIT
      </button>
    </div>
  );
};

export default OtpValidation;
